export const environment = {
  name: 'staging',
  production: false,
  uat: false,
  staging: true,
  development: false,
  baseUrl: 'https://stg-wilson-api.tracwater.online', // Sensorwise Develop Server
  portalId: '6a17e001e98329553d9006dc',
  portalTypeId: '6895970418f8a8985a2aebe2'
};
